import React from 'react';
import styles from './card.module.less';
import { Text, Title } from '@gjensidige/core-typography';
import { StepIndicator } from '../StepIndicator/StepIndicator';
import { useGlobalState } from '../../../context/GlobalContext';
import { Spacer } from '../Spacer/Spacer';
import classNames from 'classnames';
import { Spinner } from '@gjensidige/core-spinner';
export const Card = ({ title, subtitle, children, step, className, loading = false }) => {
    const { customerName } = useGlobalState();
    const maxStep = customerName ? 6 : 7;
    return (React.createElement(React.Fragment, null,
        !!customerName && React.createElement(KundeNavnBoks, { name: customerName }),
        React.createElement("div", { className: classNames(styles.card, className) },
            step && React.createElement(StepIndicator, { step: step, maxStep: maxStep }),
            title && React.createElement(CardHeader, { title: title, subtitle: subtitle }),
            loading ? (React.createElement("div", { className: styles.spinnerCentered },
                React.createElement(Spinner, { size: 32 }))) : (React.createElement(Spacer, null, children)))));
};
export const CardHeader = ({ title, subtitle }) => {
    return (React.createElement("div", { className: styles.header },
        React.createElement(Title, { tag: "h2", size: "h3" }, title),
        React.createElement(Text, null, subtitle)));
};
export const KundeNavnBoks = ({ name }) => {
    return (React.createElement("div", { className: styles.nameBox },
        React.createElement(Title, { tag: "h6" }, name)));
};
